import React, { useState, useEffect } from "react";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts";
import "echarts-gl";
import { PipelineSectorData } from "../core/_models";
import { formatBudget } from "../../../utils/formateNumber";

type Props = {
  chartData: PipelineSectorData;
  height?: number;
};

const Bar3DChart = React.forwardRef<ReactECharts, Props>(({ chartData, height }, ref) => {
  const { categories, values, colors, budgets } = chartData;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const fitted = height !== undefined;

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const series: any = categories.map((cat, i) => ({
    name: cat,
    type: "bar3D",
    data: [[i, 0, values[i]]],
    itemStyle: { color: colors[i] },
    shading: "lambert",
    barSize: isMobile ? [15, 15] : [20, 20],
    label: {
      show: true,
      formatter: (params: any) => params.value[2],
      fontSize: isMobile ? 10 : 12,
    },
  }));

  const option: echarts.EChartsOption = {
    tooltip: {
      formatter: (params: any) => {
        const idx = params.seriesIndex;
        const projectCount = values[idx] ?? 0;
        let html = `<b>${categories[idx]}</b><br/>Projects: ${projectCount.toLocaleString()}`;
        if (budgets?.[idx] !== undefined) {
          html += `<br/>Total Budget: ${formatBudget(budgets[idx])}`;
        }
        return html;
      },
    },
    grid3D: {
      boxWidth: isMobile ? 140 : fitted ? 160 : 200,
      boxDepth: isMobile ? 18 : fitted ? 22 : 30,
      top: fitted ? 0 : isMobile ? -30 : -40,
      ...(fitted ? { bottom: 16 } : {}),
      viewControl: {
        distance: isMobile ? 220 : fitted ? 160 : 180,
        alpha: isMobile ? 18 : fitted ? 20 : 10,
        beta: isMobile ? 20 : fitted ? 15 : 25,
      },
      light: {
        main: { intensity: 1, shadow: true },
        ambient: { intensity: 0.3 },
      },
    },
    xAxis3D: {
      type: "category",
      data: categories,
      name: "",
      axisLabel: {
        margin: fitted ? 14 : 8,
        fontSize: isMobile || fitted ? 11 : 12,
        interval: 0,
      },
    },
    yAxis3D: {
      type: "category",
      data: [""],
      name: ""
    },
    zAxis3D: {
      type: "value",
      name: ""
    },
    series,
  };

  return (
    <ReactECharts
      ref={ref}
      option={option}
      style={{ height: height ?? (isMobile ? 300 : 400) }}
      notMerge
    />
  );
});

export default Bar3DChart;